/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Arrows from '../../www/assets/images/arrows_select_box.svg';
import '../../www/assets/css/dropup.css';

const resetActiveListItems = () => {
	const prevSelectedOptions = document.getElementsByClassName('dropup-list-item active');
	for (let i = 0; i < prevSelectedOptions?.length; i++) {
		prevSelectedOptions[i]?.classList.remove('active');
	}
};

const DropUp = ({ showDropUp = true, resetOnProperty, itemList, onItemClick, customPlaceholder = null, customResetIndex = -1 }) => {
	const [placeholderText, setPlaceholderText] = useState(customPlaceholder);
	// Reset drop up placeholder and selected item
	useEffect(() => {
		setPlaceholderText(customPlaceholder);

		// Clear active list options
		resetActiveListItems();

		// Set active indicator on reset option on load
		const resetOption = document.getElementsByClassName('dropup-list-item')[customResetIndex];
		resetOption?.classList.add('active');
	}, [customPlaceholder, customResetIndex, resetOnProperty]);

	// Determine the longest text character length
	const textLengths = itemList.map(({ text }) => text.length);
	const longestValue = Math.max(...textLengths, customPlaceholder?.length);

	// Don't show component until designated
	if (!showDropUp) {
		return null;
	}

	return (
		<button
			className='dropup'
			style={{ width: `${44 + (longestValue * 10)}px` }}
			onClick={() => {
				const listItems = document.getElementsByClassName('dropup-list-items-container')[0];
				listItems.classList.toggle('visible');
			}}
			onBlur={() => {
				const listItems = document.getElementsByClassName('dropup-list-items-container')[0];
				listItems.classList.remove('visible');
			}}
		>
			<div className='main'>
				{placeholderText}
				<div className='arrow-wrapper'><Arrows className='svg' /></div>
			</div>
			<ul className='dropup-list-items-container'>
				{itemList.map((listItem, selectedIndex) => (
					(
						<li
							className={`dropup-list-item ${listItem.id} ${listItem.id === customResetIndex ? 'active' : ''}`}
							key={listItem.id}
							onClick={e => {
								// Clear previous active list items, add active class to selected item
								resetActiveListItems();
								e.target.classList.add('active');

								const selectedOptionText = e.target.innerText;
								onItemClick(selectedOptionText);

								// Reset placeholder to custom placeholder if select custom reset index in list
								setPlaceholderText(selectedIndex !== customResetIndex ? selectedOptionText : customPlaceholder);
							}}
						>
							{listItem.text}
						</li>
					)
				))}
			</ul>
		</button>
	);
};

DropUp.propTypes = {
	itemList: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		text: PropTypes.string
	})).isRequired,
	onItemClick: PropTypes.func.isRequired,
	resetOnProperty: PropTypes.string,
	showDropUp: PropTypes.bool,
	customPlaceholder: PropTypes.string,
	customResetIndex: PropTypes.number
};

export default React.memo(DropUp);
